/*
 * @Author: your name
 * @Date: 2020-07-31 11:59:27
 * @LastEditTime: 2020-09-22 16:53:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/router/form.js
 */
import Form from '@/pages/form/form'
import SelectDepartment from '@/pages/form/select-department/select-department'
import SelectPeople from '@/pages/form/select-people/select-people.vue'
import FormWidgetTable from '@/pages/form/widget-table/widget-table.vue'
import TableItemDetail from '@/pages/form/widget-table/table-item-detail.vue'
import DownLoadFile from '@/pages/form/download-file/download-file.vue'
import SelectData from '@/pages/form/select-data/select-data'
import SelectLocation from '@/pages/form/select-location/select-location'
import SelectArea from '@/pages/form/select-area/select-area'

// 消息提醒
import MessageRemindList from '@/pages/form/message-remind-list/message-remind-list'
import SettingMessageRemind from '@/pages/form/setting-message-remind/setting-message-remind'

const FormRoutes = {
  path: 'form-widget',
  name: 'form-widget',
  component: Form,
  children: [
    {
      path: 'select-department/:id',
      name: 'FormDepartmentSelect',
      component: SelectDepartment,
      meta: {
        title: '部门选择'
      }
    },
    {
      path: 'select-people/:id',
      name: 'FormPeopleSelect',
      component: SelectPeople,
      meta: {
        title: '人员选择'
      }
    },
    {
      path: 'table/:id',
      name: 'FormWidgetTable',
      component: FormWidgetTable,
      meta: {
        title: '表格'
      }
    },
    {
      path: 'table-item-detail/:id',
      name: 'TableItemDetail',
      component: TableItemDetail,
      meta: {
        title: '数据详情'
      }
    },
    {
      path: 'select-data/:id',
      name: 'FormWidgetLov',
      component: SelectData,
      meta: {
        title: '数据选择'
      }
    },
    {
      path: 'download-file/:id',
      name: 'FormUpload',
      component: DownLoadFile,
      meta: {
        title: '下载文件'
      }
    },
    {
      path: 'message-remind-list',
      name: 'MessageRemindList',
      component: MessageRemindList,
      meta: {
        title: '消息提醒'
      }
    },
    {
      path: 'setting-message-remind',
      name: 'SettingMessageRemind',
      component: SettingMessageRemind,
      meta: {
        title: '设置消息提醒'
      }
    },
    {
      path: 'select-location/:id',
      name: 'FormWidgetLocation',
      component: SelectLocation,
      meta: {
        title: '定位'
      }
    },
    {
      path: 'select-area/:id',
      name: 'FormWidgetArea',
      component: SelectArea,
      meta: {
        title: '地址'
      }
    }
  ]
}

export default FormRoutes
